export const GET_LIST_SV = "GET_LIST_SV";
export const COURSE_DETAIL = "COURSE_DETAIL";
export const LOG_IN = "LOG_IN";

